import { render } from "./SingleMessageForm.vue?vue&type=template&id=181da07d"
import script from "./SingleMessageForm.vue?vue&type=script&lang=js"
export * from "./SingleMessageForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Teh/Dev/web/loop-client-dashboard/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__